import _isEmpty from 'lodash/isEmpty';
import { objFirstLevelJSONStringify } from 'utils/objectManipulate';
import { froalaKeyVisionTypeMapping } from 'components/KeyVision/config';
import { defaultAnimationSetting } from 'editor/game_pointsRedeem/components/SettingPreviews/defaultGameSetting';
// import { getPromoDefaultSettingValue } from 'config/promoDefaultSettingValue';
import { getLotteryDefaultAnimationSettingValue } from 'config//lotteryDefaultAnimationSettingValue';
import { lotteryParticipantTypes } from 'config/promoLotteryTypes';
import { bgTypes } from 'styles/generateBgStyleByType';
import { fromEntries } from 'utils/core';

export default function parseAnimationSettings(settingData, lotteryType) {
    // 如果動畫設定值 (AnimationSettings) 有 key 但對應的 key 裡面是 undefined 或是動畫設定本身就是 undefined 就給空物件
    const isSettingDataValueUndefined = settingData
        ? Object.entries(settingData).some(([, value]) => typeof value === 'undefined')
        : true;
    // 如果動畫設定值 (AnimationSettings) 為空物件，則回傳空物件
    const isSettingDataEmpty = _isEmpty(settingData);

    // 如果 API animation setting 沒值，拿預設值 (mapping promo default setting value 的 settingGameStyle 到 animation setting)
    if (isSettingDataEmpty || isSettingDataValueUndefined)
        return getLotteryDefaultAnimationSettingValue(lotteryType) ?? {};

    // 後端有資料的話，值都會是字串儲存，所以要 parse
    const parsed = fromEntries(
        Object.entries(settingData).map(([key, value]) => {
            try {
                if (typeof value === 'string') {
                    return [key, JSON.parse(value)];
                } else {
                    return [key, value];
                }
            } catch (err) {
                return [key, {}];
            }
        })
    );

    // 用 keyVisionSettings 與 keyVision 確認是否是新版 AnimationSettings
    return parsed?.keyVisionSettings ? parsed : migratedAnimationSettings(parsed, lotteryType);
}

export const stringifyAnimationSetting = settingData => {
    return objFirstLevelJSONStringify(settingData);
};

const migratedAnimationSettings = (deprecatedSetting, lotteryType) => {
    const newSettings = getLotteryDefaultAnimationSettingValue(lotteryType);
    let animationSetting = {};
    if (Object.keys(newSettings).length > 0) {
        switch (lotteryType) {
            case lotteryParticipantTypes.PICK_THE_PRIZE:
                animationSetting = {
                    keyVisionSettings: {
                        ...newSettings.keyVisionSettings,
                        isShowKeyVision:
                            deprecatedSetting?.keyVisual?.isShowKeyVision ??
                            deprecatedSetting?.keyVision?.isShowKeyVision ??
                            newSettings.keyVisionSettings.isShowKeyVision,
                        bgType: bgTypes.IMG,
                        bgColor:
                            deprecatedSetting?.keyVisual?.colorBg ??
                            deprecatedSetting?.keyVision?.colorBg ??
                            newSettings.keyVisionSettings.bgColor,
                        defaultMainVisionType:
                            deprecatedSetting?.keyVisual?.isUseCustomKeyVision ??
                            deprecatedSetting?.keyVision?.isUseCustomKeyVision
                                ? froalaKeyVisionTypeMapping.IMAGE
                                : froalaKeyVisionTypeMapping.COLOR,
                        customImgUrl:
                            deprecatedSetting?.keyVisual?.customImgUrl ??
                            deprecatedSetting?.keyVision?.customImgUrl ??
                            newSettings.keyVisionSettings.customImgUrl,
                        customMobileImgUrl:
                            deprecatedSetting?.keyVisual?.customImgUrl ??
                            deprecatedSetting?.keyVision?.customImgUrl ??
                            newSettings.keyVisionSettings.customMobileImgUrl
                    },
                    prizeCardStyleSettings: {
                        ...newSettings.prizeCardStyleSettings,
                        type:
                            deprecatedSetting?.pickThePrizeCardStyle?.type ??
                            newSettings.prizeCardStyleSettings.type,
                        isShowCaption:
                            deprecatedSetting?.pickThePrizeCardStyle?.isShowCaption ??
                            newSettings.prizeCardStyleSettings.isShowCaption,
                        textColor:
                            deprecatedSetting?.pickThePrizeCardStyle?.colorText ??
                            newSettings.prizeCardStyleSettings.textColor,
                        bgColor:
                            deprecatedSetting?.pickThePrizeCardStyle?.colorBg ??
                            newSettings.prizeCardStyleSettings.bgColor
                    },
                    prizeCardOrderSettings: {
                        ...newSettings.prizeCardOrderSettings,
                        prizesOrder:
                            deprecatedSetting?.prizeCardOrder?.prizesOrder ??
                            newSettings.prizeCardOrderSettings.prizesOrder
                    },
                    prizeCardLayoutSettings: {
                        ...newSettings.prizeCardLayoutSettings,
                        ...(deprecatedSetting?.prizeCardLayout ??
                            newSettings.prizeCardLayoutSettings)
                    },
                    actionButtonSettings: {
                        ...newSettings.actionButtonSettings,
                        color:
                            deprecatedSetting?.button?.color ??
                            newSettings.actionButtonSettings.color,
                        bgColor:
                            deprecatedSetting?.button?.colorBg ??
                            newSettings.actionButtonSettings.bgColor,
                        defaultBackgroundType: deprecatedSetting?.button?.isUseCustomImg
                            ? froalaKeyVisionTypeMapping.IMAGE
                            : froalaKeyVisionTypeMapping.COLOR,
                        customImgUrl:
                            deprecatedSetting?.button?.customImgUrl ??
                            newSettings.actionButtonSettings.bgColor
                    },
                    backgroundSettings: {
                        ...newSettings.backgroundSettings,
                        bgColor:
                            deprecatedSetting?.BackgroundStyle?.colorBg ??
                            newSettings.backgroundSettings.bgColor,
                        defaultBackgroundType: deprecatedSetting?.BackgroundStyle?.isUseCustomImg
                            ? froalaKeyVisionTypeMapping.IMAGE
                            : froalaKeyVisionTypeMapping.COLOR,
                        customImgUrl:
                            deprecatedSetting?.BackgroundStyle?.customImgUrl ??
                            newSettings.backgroundSettings.customImgUrl
                    }
                };
                break;
            case lotteryParticipantTypes.POINTS_REDEEM:
                animationSetting = {
                    keyVisionSettings: {
                        ...newSettings.keyVisionSettings,
                        isShowKeyVision:
                            deprecatedSetting?.keyVision?.isShowKeyVision ??
                            newSettings.keyVisionSettings.isShowKeyVision,
                        bgType: bgTypes.FROALA,
                        bgColor:
                            deprecatedSetting?.keyVision?.colorBg ??
                            newSettings.keyVisionSettings.bgColor,
                        defaultMainVisionType: deprecatedSetting?.keyVision?.isUseCustomKeyVision
                            ? froalaKeyVisionTypeMapping.IMAGE
                            : froalaKeyVisionTypeMapping.COLOR,
                        customImgUrl:
                            deprecatedSetting?.keyVision?.customImgUrl ??
                            newSettings.keyVisionSettings.customImgUrl,
                        customMobileImgUrl:
                            deprecatedSetting?.keyVision?.customImgUrl ??
                            newSettings.keyVisionSettings.customMobileImgUrl,
                        froalaEditor:
                            deprecatedSetting?.keyVision?.froalaEditor ??
                            newSettings.keyVisionSettings.froalaEditor
                    },
                    prizeCardStyleSettings: {
                        ...newSettings.prizeCardStyleSettings,
                        textColor:
                            deprecatedSetting?.prizeCardStyle?.colorText ??
                            newSettings.prizeCardStyleSettings.textColor,
                        bgColor:
                            deprecatedSetting?.prizeCardStyle?.colorBg ??
                            newSettings.prizeCardStyleSettings.bgColor,
                        buttonTextColor:
                            deprecatedSetting?.prizeCardStyle?.colorButtonText ??
                            newSettings.prizeCardStyleSettings.buttonTextColor,
                        buttonBgColor:
                            deprecatedSetting?.prizeCardStyle?.colorButtonBg ??
                            newSettings.prizeCardStyleSettings.buttonBgColor
                    },
                    prizeCardOrderSettings: {
                        ...newSettings.prizeCardOrderSettings,
                        prizesOrder:
                            deprecatedSetting?.prizeCardOrder?.prizesOrder ??
                            newSettings.prizeCardOrderSettings.prizesOrder
                    },
                    prizeCardLayoutSettings: {
                        ...newSettings.prizeCardLayoutSettings,
                        ...(deprecatedSetting?.prizeCardLayout ??
                            newSettings.prizeCardLayoutSettings)
                    },
                    backgroundSettings: {
                        ...newSettings.backgroundSettings,
                        bgColor:
                            deprecatedSetting?.BackgroundStyle?.colorBg ??
                            newSettings.backgroundSettings.bgColor,
                        defaultBackgroundType: deprecatedSetting?.BackgroundStyle?.isUseCustomImg
                            ? froalaKeyVisionTypeMapping.IMAGE
                            : froalaKeyVisionTypeMapping.COLOR,
                        customImgUrl:
                            deprecatedSetting?.BackgroundStyle?.customImgUrl ??
                            newSettings.backgroundSettings.customImgUrl
                    }
                };
                break;
            default:
                animationSetting = newSettings;
        }
        return animationSetting;
    }
    return deprecatedSetting;
};

export const migrateAnimationSetting2SettingGameStyle = (
    promoDefaultSettingValue,
    AnimationSettings
) => {
    const migratedDefaultValue = {
        ...promoDefaultSettingValue,
        settingGameStyle: {
            keyVisionSettings: {
                bgType:
                    AnimationSettings?.keyVision?.bgType ??
                    promoDefaultSettingValue.settingGameStyle?.keyVisionSettings?.bgType ??
                    defaultAnimationSetting.keyVision.bgType,
                bgColor:
                    AnimationSettings?.keyVision?.colorBg ??
                    promoDefaultSettingValue.settingGameStyle.keyVisionSettings?.bgColor ??
                    defaultAnimationSetting.keyVision.colorBg,
                customImgUrl:
                    AnimationSettings?.keyVision?.customImgUrl ??
                    promoDefaultSettingValue.settingGameStyle.settingGameStyle?.customImgUrl ??
                    defaultAnimationSetting.keyVision.customImgUrl,
                customMobileImgUrl:
                    AnimationSettings?.keyVision?.customMobileImgUrl ??
                    promoDefaultSettingValue.settingGameStyle?.keyVisionSettings
                        ?.customMobileImgUrl ??
                    defaultAnimationSetting.keyVision.customMobileImgUrl,
                defaultMainVisionType:
                    AnimationSettings?.keyVision?.isUseCustomKeyVision ??
                    promoDefaultSettingValue.settingGameStyle.keyVisionSettings
                        ?.defaultMainVisionType
                        ? froalaKeyVisionTypeMapping.IMAGE
                        : froalaKeyVisionTypeMapping.COLOR,
                froalaEditor:
                    AnimationSettings?.keyVision?.froalaEditor ??
                    promoDefaultSettingValue.settingGameStyle.keyVisionSettings?.froalaEditor ??
                    defaultAnimationSetting.keyVision.froalaEditor,
                isShowKeyVision:
                    AnimationSettings?.keyVision?.isShowKeyVision ??
                    promoDefaultSettingValue.settingGameStyle.keyVisionSettings?.isShowKeyVision ??
                    defaultAnimationSetting.keyVision.isShowKeyVision
            },
            prizeCardStyleSettings: {
                textColor:
                    AnimationSettings?.prizeCardStyle?.colorText ??
                    promoDefaultSettingValue.settingGameStyle?.prizeCardStyleSettings?.textColor ??
                    defaultAnimationSetting.prizeCardStyle.colorText,
                bgColor:
                    AnimationSettings?.prizeCardStyle?.colorBg ??
                    promoDefaultSettingValue.settingGameStyle?.prizeCardStyleSettings?.bgColor ??
                    defaultAnimationSetting.prizeCardStyle.colorBg,
                buttonTextColor:
                    AnimationSettings?.prizeCardStyle?.colorButtonText ??
                    promoDefaultSettingValue.settingGameStyle?.prizeCardStyleSettings
                        ?.buttonTextColor ??
                    defaultAnimationSetting.prizeCardStyle.colorButtonText,
                buttonBgColor:
                    AnimationSettings?.prizeCardStyle?.colorButtonBg ??
                    promoDefaultSettingValue.settingGameStyle?.prizeCardStyleSettings
                        ?.buttonBgColor ??
                    defaultAnimationSetting.prizeCardStyle.colorButtonBg
            },
            prizeCardOrderSettings: {
                prizesOrder:
                    AnimationSettings?.prizeCardOrder?.prizesOrder ??
                    defaultAnimationSetting.defaultAnimationSetting.prizeCardOrder
            },
            prizeCardLayoutSettings:
                AnimationSettings?.prizeCardLayout ??
                defaultAnimationSetting.defaultAnimationSetting.prizeCardLayout,
            backgroundSettings: {
                bgColor:
                    AnimationSettings?.BackgroundStyle?.colorBg ??
                    promoDefaultSettingValue.settingGameStyle?.backgroundSettings?.bgColor ??
                    defaultAnimationSetting.BackgroundStyle.colorBg,
                customImgUrl:
                    AnimationSettings?.BackgroundStyle?.customImgUrl ??
                    promoDefaultSettingValue.settingGameStyle?.backgroundSettings?.customImgUrl ??
                    defaultAnimationSetting.BackgroundStyle.customImgUrl,
                defaultBackgroundType: AnimationSettings?.BackgroundStyle?.isUseCustomImg
                    ? froalaKeyVisionTypeMapping.IMAGE
                    : froalaKeyVisionTypeMapping.COLOR
            }
        }
    };
    return migratedDefaultValue;
};
